
export default {
    props: {
        addOne: Function
    },
}
